var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountMultiplePlusFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 17v2H7v-2s0-4 6-4 6 4 6 4zm-3-9a3 3 0 10-6 0 3 3 0 006 0zm3.2 5.06A5.6 5.6 0 0121 17v2h3v-2s0-3.45-4.8-3.94zM18 5a2.91 2.91 0 00-.89.14 5 5 0 010 5.72c.288.093.588.14.89.14a3 3 0 000-6zM8 10H5V7H3v3H0v2h3v3h2v-3h3v-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMultiplePlusFill);
export default __webpack_public_path__ + "45c33f7b3fab5ce15c1256d071d878df.svg";
export { ForwardRef as ReactComponent };